module.exports = __webpack_public_path__ + "assets/img/icon_tx.c92c12dd.png";